import { BrowserRouter, Route, Routes } from "react-router-dom";
import DashboardCars from "./pages/Dashboard/Cars";
import CarDetail from "./pages/landing/CarDetail";
import Cars from "./pages/landing/Cars";
import Collection from "./pages/landing/Collection";
import Homepage from "./pages/landing/Homepage";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" Component={Homepage} />
        <Route path="/dashboard/cars" Component={DashboardCars} />
        <Route path="/cars" Component={Cars} />
        <Route path="/collection" Component={Collection} />
        <Route path="/detail/:id" Component={CarDetail} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
